import jQuery from 'jquery';

// prendi un alias LOCALE che nessuno può sovrascrivere
const $ = jQuery;

$(document).ready(function () {

  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 86400000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Newsletter popup
  const x = getCookie("newsletter-5");
  if (!x) {
    setCookie("newsletter-5", "true", 1);
  }

  window.addEventListener('update-url-path', (e) => {
    let p = e.detail && e.detail.path;
    if (!p) return;
    if (!p.startsWith('/')) p = '/' + p;
    const url = location.origin + p;
    history.replaceState({}, '', url);
    console.log(url);
  });

  window.addEventListener("set-cookie", (event) => {
    setCookie("newsletter-5", "true", event.detail.expiry);
  });

  window.addEventListener("convert-sell", (event) => {
    var ud = event.detail.user_data || {};
    var gtagUserData = {};
    if (ud.email)      gtagUserData.email        = ud.email;
    if (ud.phone)      gtagUserData.phone_number = ud.phone.startsWith('+') ? ud.phone : ('+39' + ud.phone);
    if (ud.first_name || ud.last_name) {
      gtagUserData.address = {};
      if (ud.first_name) gtagUserData.address.first_name = ud.first_name;
      if (ud.last_name)  gtagUserData.address.last_name  = ud.last_name;
    }
    if (Object.keys(gtagUserData).length) {
      gtag('set', 'user_data', gtagUserData);
    }
    gtag("event", "conversion", {
      send_to: "AW-16496435196/F9elCJrTkM4ZEPy_jro9",
      value: event.detail.total,
      currency: "EUR",
      transaction_id: "MRS" + event.detail.order.id,
      event_callback: null,
    });

    window._tpt = window._tpt || [];
    window._tpt.push({
      event: "setAccount",
      id: "bGNaM014SDZrYjhXYVYrSjNvTXJMSjJmYS9rNVpuK3EyRHZrRmxUVTJGUT01",
    });
    window._tpt.push({ event: "setOrderId", order_id: event.detail.order.id });
    window._tpt.push({ event: "setEmail", email: event.detail.order.user.email });
    event.detail.order.items.forEach((item) => {
      window._tpt.push({ event: "addItem", sku: item.sku, product_name: item.name });
    });
    window._tpt.push({ event: "setAmount", amount: event.detail.total });
    window._tpt.push({ event: "orderSubmit" });
  });

  // Carousel
  $(".carousel").carousel({ pause: true, interval: false });

  $(document).on("click", ".retrieve", function () {
    const id = $(this).data("id");
    if (!id) return;

    const $button = $(this);
    $button.prop("disabled", true);

    $.get("/administrator/retrieve/image/" + id)
      .done(function (data) {
        if (data && data.url) {
          $(".destination-retrieve[data-id='" + id + "']").attr("src", data.url + "?v=" + Date.now());
        }
      })
      .always(function () {
        $button.prop("disabled", false);
      });
  });

  // Sidebar toggle (mobile)
  $(document).on("click", "#menu-toggle", function (e) {
    e.preventDefault();
    $("#sidebar-wrapper").toggleClass("sidebar-toggled");
    $("#sidebar-shadow").toggleClass("sidebar-shadow-toggled");
  });

  $(window).on("resize", function () {
    if ($(window).width() >= 990) {
      $("#sidebar-wrapper").removeClass("sidebar-toggled");
      $("#sidebar-shadow").removeClass("sidebar-shadow-toggled");
    }
  });

  $(document).on("click", "#sidebar-close", function (e) {
    e.preventDefault();
    $("#sidebar-wrapper").removeClass("sidebar-toggled");
    $("#sidebar-shadow").removeClass("sidebar-shadow-toggled");
  });

  // Accordion toggle
  $("[id^=sct-accordion-collapse-], [id^=sidebar-accordion-collapse-]").on(
    "show.bs.collapse",
    function () {
      const id = $(this).attr("id").replace("accordion-collapse", "i-collapse");
      $("#" + id).removeClass("fa-plus").addClass("fa-minus");
    }
  );

  $("[id^=sct-accordion-collapse-], [id^=sidebar-accordion-collapse-]").on(
    "hidden.bs.collapse",
    function () {
      const id = $(this).attr("id").replace("accordion-collapse", "i-collapse");
      $("#" + id).removeClass("fa-minus").addClass("fa-plus");
    }
  );

  $(document).on("click", "[id*=i-collapse]", function (e) {
    e.preventDefault();
    e.stopPropagation();
  });

  $(document).on("click", "div[id^=accordion-collapse-]", function (e) {
    e.stopPropagation();
  });

  // Carousel items shuffle
  $("[id^=carousel-main]").on("slide.bs.carousel", function (e) {
    const $e = $(e.relatedTarget);
    const idx = $e.index();
    const itemsPerSlide = 5;
    const totalItems = $(this).find(".carousel-item").length;

    if (idx >= totalItems - (itemsPerSlide - 1)) {
      const it = itemsPerSlide - (totalItems - idx);
      for (let i = 0; i < it; i++) {
        if (e.direction === "left") {
          $(this).find(".carousel-item").eq(i).appendTo($(this).find(".carousel-inner"));
        } else {
          $(this).find(".carousel-item").eq(0).appendTo($(this).find(".carousel-inner"));
        }
      }
    }
  });

  // Keep token alive
  setInterval(() => {
    $.post("/keep-token-alive", {
      _token: $('meta[name="csrf-token"]').attr("content"),
    }).then((result) => {
      console.log(new Date(), result);
    });
  }, 1000 * 60 * 100);

  // Setup CSRF for all AJAX
  $.ajaxSetup({
    headers: {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
  });

  // Tooltip
  if (!("ontouchstart" in window)) {
    $('[data-toggle="tooltip"]').tooltip({ html: true, placement: "bottom" });
  }
});
